import React from "react";
import LayoutClasses from "./Layout.module.css";
import useStore from "../../Store";
import { useEffect } from "react";
import Navbar from "../Navbar/Navbar";
function Layout({ children, Active }) {
    const showNav = useStore((state) => state.showNavbar);
    const setShowNav = useStore((state) => state.setshowNavbar);
    const setActiveTab = useStore((State) => State.setActiveTab);

    return (
        <div className={LayoutClasses["Wrapper"]}>
            <div className={LayoutClasses.Navcontainer}>
                <Navbar Active={Active} setShow={setShowNav} show={showNav} />
            </div>
            <div>{children}</div>
        </div>

    );
}

export default Layout;
